import React, { FC, FocusEvent, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Input } from 'dibs-elements/exports/Input';
import { Button } from 'dibs-elements/exports/Button';
import { Spinner } from 'dibs-elements/exports/Spinner';
import { TextArea } from 'dibs-elements/exports/TextArea';
import { DeleteArticleConfirmationModal } from './DeleteArticleConfirmationModal';

import styles from '../OverviewArticles.scss';

import { EditableArticleType } from '../OverviewArticles';

type Props = {
    article: EditableArticleType;
    isSaving: boolean;
    onChangeTitle: (e: FocusEvent<HTMLInputElement>) => void;
    onChangeDescription: (e: FocusEvent<HTMLTextAreaElement>) => void;
    onSave: () => void;
    onCancel: () => void;
    onDelete: () => void;
};

export const Edit: FC<Props> = ({
    article,
    onChangeTitle,
    onChangeDescription,
    onSave,
    onCancel,
    onDelete,
    isSaving,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div key={`overview-article-editing`} className={`${styles.editingArticleWrapper} colXs12`}>
            <div className={styles.editingArticleContent}>
                {article.photoPath ? (
                    <div className={styles.articleImage}>
                        <img src={article.photoPath} className={styles.image} />
                    </div>
                ) : null}
                <div className={styles.articleInfo}>
                    <div className={styles.editElement}>
                        <Input
                            defaultValue={article.title || ''}
                            dataTn="article-title-edit"
                            onBlur={onChangeTitle}
                        />
                    </div>
                    <div className={styles.editElement}>
                        <TextArea
                            dataTn="article-description-edit"
                            value={article.description || ''}
                            onBlur={onChangeDescription}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.editingButtonWrapper}>
                <Button
                    className={styles.saveCancelButton}
                    dataTn="article-button-cancel"
                    size="medium"
                    onClick={onCancel}
                    type="secondary"
                >
                    <FormattedMessage
                        id="abt.designProfile.overview.article.cancel"
                        defaultMessage="Cancel"
                    />
                </Button>
                <Button
                    className={styles.saveCancelButton}
                    dataTn="article-button-save"
                    size="medium"
                    onClick={onSave}
                >
                    <FormattedMessage
                        id="abt.designProfile.overview.article.save"
                        defaultMessage="Save"
                    />
                </Button>
            </div>
            <div className={styles.deleteRow} onClick={() => setIsModalOpen(true)}>
                <FormattedMessage
                    id="abt.designProfile.overview.article.remove"
                    defaultMessage="Remove"
                />
            </div>
            {isSaving ? (
                <div className={styles.savingIndicator}>
                    <Spinner size="tiny" />
                </div>
            ) : null}
            <DeleteArticleConfirmationModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                articleName={article?.title || ''}
                onDelete={() => {
                    onDelete();
                    setIsModalOpen(false);
                }}
            />
        </div>
    );
};
